// ✅ BetAmountPage.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar2 from "../components/navbar/Navbar2";
import AOS from "aos";
import "aos/dist/aos.css";
import { socket } from "../api";
import LoadingPage from "./LoadingPage";
import DigitalTimer from "./DigitalTimer";

const BetAmountPage = () => {
  const navigate = useNavigate();
  const [rooms, setRooms] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    AOS.init({ duration: 500, easing: "ease-in-sine" });

    // 🔁 Always request full room list on mount
    socket.emit("get-rooms");

    // ✅ FULL SNAPSHOT (authoritative)
    socket.on("room-list", (list) => {
      setRooms((prev) => {
        // First load → sort and set
        if (prev.length === 0) {
          return [...list].sort((a, b) => Number(a.id) - Number(b.id));
        }

        // After first load → MERGE only (no replace, no sort)
        return prev.map((room) => {
          const fresh = list.find((r) => r.roomId === room.roomId);
          return fresh ? { ...room, ...fresh } : room;
        });
      });

      setLoading(false);
    });

    // ✅ SINGLE ROOM UPDATE (authoritative)
    socket.on("room-update", (updatedRoom) => {
      setRooms((prev) =>
        prev.map((room) =>
          room.roomId === updatedRoom.roomId
            ? { ...room, ...updatedRoom }
            : room,
        ),
      );
    });

    // 🔄 Safety sync every second (prevents stale UI)
    const syncInterval = setInterval(() => {
      socket.emit("get-rooms");
    }, 1000);

    return () => {
      socket.off("room-list");
      socket.off("room-update");
      clearInterval(syncInterval);
    };
  }, []);

  const handleJoinClick = (room) => {
    if (room.status === "playing") {
      navigate("/play", {
        state: {
          roomInfo: room,
        },
      });
    } else {
      navigate(
        `/select-cards?room=${room.roomId}&stake=${room.amount}&win=${room.winAmount}`,
      );
    }
  };

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-black via-zinc-950 to-gray-900 text-white">
      <div className="fixed left-0 right-0 top-0 z-50 bg-gradient-to-r from-black via-gray-900 to-black border-b border-yellow-500/20">
        <Navbar2 />
      </div>

      <div className="text-center pt-20">
        <h1 className="text-2xl font-semibold font-serif text-yellow-400 tracking-wide">
          Please Choose Your Stake
        </h1>
      </div>

      <div className="mt-10 flex justify-center">
        {/* ✅ Outer container glow */}
        <div className="w-full max-w-4xl rounded-lg overflow-hidden shadow-xl px-1">
          {/* ✅ Header as card */}
          <div
            className="
grid grid-cols-4 text-center font-semibold py-4 mb-3
rounded-xl
bg-gradient-to-r from-zinc-900 to-gray-800
border border-yellow-500/20
shadow-lg
font-serif
text-yellow-400
"
          >
            <div>Stake</div>
            <div>Active</div>
            <div>Possible Win</div>
            <div>Join</div>
          </div>

          {rooms.map((room) => {
            return (
              <div
                key={room.roomId}
                className="
grid grid-cols-4 text-center items-center
py-1 my-3
rounded-xl
bg-gradient-to-r from-zinc-900 via-gray-900 to-zinc-800
shadow-[0_8px_20px_rgba(0,0,0,0.6)]
border border-yellow-500/10
hover:scale-[1.01]
hover:border-yellow-400/30
transition
font-serif
"
              >
                <div>{room.amount} Birr</div>

                <div className="text-sm">
                  {room.status === "counting" ? (
                    <DigitalTimer seconds={room.countdown} />
                  ) : room.status === "playing" ? (
                    <span className="text-green-400">Playing</span>
                  ) : (
                    <span className="text-gray-300">Waiting</span>
                  )}
                </div>

                <div className="text-yellow-400 font-semibold">
                  {room.winAmount ? `${room.winAmount} Birr` : "—"}
                </div>

                <div>
                  <button
                    onClick={() => handleJoinClick(room)}
                    className={`px-4 py-2 rounded-lg font-semibold ${
                      room.status === "playing"
                        ? "bg-gray-700 text-white"
                        : "bg-gradient-to-r from-yellow-600 to-yellow-700 text-black hover:opacity-90"
                    }`}
                  >
                    {room.status === "playing" ? "Open »" : "» Join"}
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default BetAmountPage;
